module.exports = __webpack_public_path__ + "static/media/bz.f220183f.svg";